import React, { useState, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreateForm from '../../../forum/sections/create-form';
import { combineClassNames } from '../../../../app/functions';
import closeIconPath from '../../../../assets/icons/login-x-icon.svg';
import Loader from '../../../../components/common/loader';
import * as popups from '../../../../constants/popup-types';
import { addPopup, forumCreatePost } from '../../../../redux/actions';
import './index.scss';

const CreateForumPostPopup = ({ afterCreation, handleClose }) => {
  const dispatch = useDispatch();

  const { forumConfiguration } = useSelector((store) => store.config.Parameters);
  const translations = useSelector((store) => store.config.Translations);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isProcessingPost, setIsProcessingPost] = useState(false);
  const [wasPostCreated, setWasPostCreated] = useState(false);
  const [wasPostTouched, setWasPostTouched] = useState(false);

  const openPopup = () => setIsPopupVisible(true);

  const closePopup = () => {
    // Prevent closing the popup while waiting for a response
    if (isProcessingPost) return;

    // Confirm before closing the popup if the user has already touched the form (but not submitted it)
    if (!wasPostCreated && wasPostTouched) {
      dispatch(addPopup({
        type: popups.GENERAL_MESSAGE,
        text: translations['forum_create_form_touched_popup_message'],
        btnText: translations['forum_create_form_touched_popup_button'],
        action: () => {
          setIsPopupVisible(false);
          setTimeout(handleClose, 250);
        },
      }));
      return;
    }

    setIsPopupVisible(false);
    setTimeout(handleClose, 250);
  };

  const handleBackdropClick = ({ target }) => {
    // Close popup only if backdrop was clicked, not its children
    if (target.classList.contains('backdrop')) {
      closePopup();
    }
  };

  const handleFormSubmit = (formData) => {
    setIsProcessingPost(true);

    dispatch(forumCreatePost(
      // General Configuration
      formData,
      forumConfiguration,

      // Handle Success
      () => {
        afterCreation();
        setIsProcessingPost(false);
        setWasPostCreated(true);
      },

      // Handle Failure
      () => setIsProcessingPost(false),
    ));
  };

  const handleFormTouch = () => setWasPostTouched(true);

  useLayoutEffect(openPopup, []);

  return (
    <div
      className={combineClassNames(
        'backdrop',
        isPopupVisible && 'active',
      )}
      onClick={handleBackdropClick}
    >
      <div className="create-forum-post-popup">
        <button
          type="button"
          className="popup-close-button"
          onClick={closePopup}
          aria-label="Close Popup"
        >
          <img src={closeIconPath} alt="Close Icon" />
        </button>

        <div className="popup-content">
          <h2 className="popup-title">
            {translations['forum_create_post_popup_title']}
          </h2>

          {wasPostCreated ? (
            <p className="popup-success-message">
              {translations['forum_create_post_success_message']}
            </p>
          ) : (
            <CreateForm
              isProcessing={isProcessingPost}
              onSubmit={handleFormSubmit}
              onTouch={handleFormTouch}
            />
          )}

          {isProcessingPost && (
            <Loader className="popup-loader" />
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateForumPostPopup;
